/**
 * XBIT-4826: the `storage` event does not fire in the tab that wrote the change, so a tab that ends its own
 * session (the interceptor clearing `auth_data` after SESSION_REVOKED, or a refresh answered 401) announces it
 * with this in-tab event. `SessionSync` turns it, like another tab's sign-out, into a return to the sign-in page.
 */
export const SESSION_ENDED_EVENT = 'xbit-admin-session-ended';

export function notifySessionEnded(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SESSION_ENDED_EVENT));
}
